<script>
  import BodyTypeFilter   from './body-type-filter/body-type-filter.svelte';
  import DriverFilter     from './driver-filter/driver-filter.svelte';
  import DriverSizeFilter from './driver-size-filter/driver-size-filter.svelte';
</script>

<style>
  #optional-filters h2 {
    margin-bottom: 10px;
  }

  #optional-filters :global(.filter-name) {
    width: 102px;
  }

  #optional-filters :global(.checkbox-filter-with-bg) {
    background-position: bottom 5px left 37px;
    background-repeat: no-repeat;
    border: 1px solid #333;
    display: inline-block;
    height: 55px;
    vertical-align: middle;
    width: 91px;
  }

  #optional-filters :global(.checkbox-filter-with-bg label) {
    cursor: pointer;
    display: block;
    height: 54px;
    margin: 0;
    padding: 1px 23px 0 3px;
    position: relative;
    width: 89px;
  }

  #optional-filters :global(.checkbox-filter-with-bg label input) {
    bottom: 2px;
    cursor: pointer;
    left: 2px;
    position: absolute;
  }
</style>

<template lang="pug" src="./optional-filters.pug"></template>
